import { forwardRef } from "react";
import { Typography, ITypographyProps } from "../Typography";

export interface IPProps extends Omit<ITypographyProps, "as"> {}

export const P = forwardRef<HTMLParagraphElement, IPProps>((props, ref) => {
  return <Typography ref={ref} as="p" variant="body" {...props} />;
});

P.displayName = "P";
